import React, { useEffect, useState } from "react";
import { useUser } from "../../context/UserContext";
import { fetchStationPerformance } from "../../api/analytics/getStationPerformance";
import { useNavigate } from "react-router-dom";

const StationOverview: React.FC = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useUser(); // ✅ Destructure isLoading
  const [stations, setStations] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadStations = async () => {
      // Wait for user to be loaded and have org_id
      if (isLoading || !user || !user.org_id) {
        console.warn(
          "User or org_id not available. Skipping fetch or waiting for data."
        );
        setLoading(false);
        return;
      }

      try {
        const data = await fetchStationPerformance(user.org_id);
        setStations(data);
      } catch (err) {
        console.error("Failed to fetch station performance:", err);
      } finally {
        setLoading(false);
      }
    };

    loadStations();
  }, [user, isLoading]); // ✅ Watch both user and isLoading

  const handleViewAll = () => {
    navigate("/stations");
  };

    const handleViewDetails = (stationId: string) => {
    navigate(`/stations/${stationId}`);
  };

  const visibleStations = stations.slice(0, 5);

  if (isLoading) {
    return (
      <div className="card station-list-card">
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="card station-list-card">
      <div className="section-header">
        <h2>Station Overview</h2>
        <button className="view-all-btn" onClick={handleViewAll}>
          View all stations
        </button>
      </div>
      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        <div className="station-list">
          {visibleStations.map((station, index) => {
            const active = station.active_chargers;
            const nonActive = station.total_chargers - station.active_chargers;
            return (
              <div key={index} className="station-item" onClick={() => handleViewDetails(station.station_id)}>
                <div className="station-info">
                  <h4>
                    {station.station_name}{" "}
                    <span
                      className={`status-tag ${
                        active > 0 ? "online" : "maintenance"
                      }`}
                    >
                      {active > 0 ? "online" : "maintenance"}
                    </span>
                  </h4>
                  <p>
                    {active} active chargers | {nonActive} non-active chargers
                  </p>
                  {/* <p>
-                    Total sessions: {station.total_sessions} | Energy consumed:{" "}
-                    {station.consumed_kwh.toFixed(2)} kWh
-                  </p> */}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default StationOverview;